import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d11542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods" }
const _hoisted_2 = {
  key: 0,
  class: "goods_list"
}
const _hoisted_3 = { class: "list_operate" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "goods_item_content" }
const _hoisted_6 = { class: "goods_item_desc" }
const _hoisted_7 = { class: "goods_item_footer" }
const _hoisted_8 = { class: "goods_item_footer_edit" }
const _hoisted_9 = {
  key: 1,
  class: "empty_wrap"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { reactive, watch, ref, unref } from 'vue';
import { Modal } from 'ant-design-vue';
import type { Imodal } from '@/views/live/place/Place.vue';
import { VueDraggableNext } from 'vue-draggable-next';
import { emptyDataImgTxt } from '@/assets';
import ModalCreateVideo from './ModalCreateVideo.vue';
import { Videoform } from '../type';
import { dragDrop } from '@/utils/format/dragDrop';

interface IProps {
  modelValue: Videoform[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoList',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: Videoform[];
};

const aModal = Modal;
const draggable = VueDraggableNext;
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});


const form = ref<Videoform[]>([]);
unref(props.modelValue).forEach((e, index) => {
  form.value[index] = e;
  form.value[index].isShowEdit = false;
});

watch(form.value, (newVal) => {
  emit('update:modelValue', newVal);
});

const lastkey = ref(0);
const onEdit = (key: number) => {
  if (lastkey.value !== key) {
    form.value[lastkey.value].isShowEdit = false;
    lastkey.value = key;
  }
  form.value[key].isShowEdit = !form.value[key].isShowEdit;
};
const onRemove = (key: number) => {
  form.value.splice(key, 1);
};
const onAddList = (data: Videoform[]) => {
  data.forEach((e) => {
    if (form.value.findIndex((obj) => obj.id === e.id) === -1) {
      form.value.push(e);
    }
  });
};

//  modal
const sonRef = ref();
const createModal = reactive<Imodal>({
  title: '添加视频',
  visible: false,
  loading: false,
});
const openCreateModal = () => {
  createModal.visible = true;
};
const closeCreateModal = () => {
  createModal.visible = false;
  createModal.loading = false;
  if (sonRef.value) {
    sonRef.value.choice_all = false;
    sonRef.value.changeItemMarkAll();
  }
};
const createFolder = () => {
  sonRef.value.getSelectData();
  closeCreateModal();
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (form.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              class: "mod_modal_btn sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openCreateModal()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(draggable), _mergeProps({
            class: "goods_item_wrap c_scroll",
            list: form.value
          }, dragOptions.value, { onDrop: _unref(dragDrop) }), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "goods_item list-group-item",
                  key: index
                }, [
                  _createElementVNode("img", {
                    class: "goods_item_img",
                    src: item.cover_url,
                    alt: ""
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("h4", { class: "goods_item_title mod_ellip" }, _toDisplayString(item.title), 513), [
                      [_vShow, !item.isShowEdit]
                    ]),
                    _withDirectives(_createVNode(_component_a_input, {
                      class: "c_input",
                      value: item.title,
                      "onUpdate:value": ($event: any) => ((item.title) = $event),
                      size: "small"
                    }, null, 8, ["value", "onUpdate:value"]), [
                      [_vShow, item.isShowEdit]
                    ]),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.start_at), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_a_button, {
                          class: "gifbtn",
                          type: "link",
                          onClick: ($event: any) => (onEdit(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("设置标题")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_a_button, {
                          class: "gifbtn",
                          type: "link",
                          onClick: ($event: any) => (onRemove(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("从列表移除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 16, ["list", "onDrop"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("img", {
            class: "empty_tbody_img",
            src: _unref(emptyDataImgTxt),
            alt: ""
          }, null, 8, _hoisted_10),
          _createElementVNode("p", null, [
            _createTextVNode(" 暂无信息，可点击 "),
            _createVNode(_component_a_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openCreateModal())),
              type: "link",
              class: "empty_tbody_link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            }),
            _createTextVNode(" 创建～ ")
          ]),
          _hoisted_11
        ])),
    _createVNode(_unref(aModal), {
      visible: createModal.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((createModal.visible) = $event)),
      title: createModal.title,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (closeCreateModal())),
      width: 1090,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: closeCreateModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          loading: createModal.loading,
          onClick: createFolder
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(ModalCreateVideo, {
          ref_key: "sonRef",
          ref: sonRef,
          "onGet:sonList": onAddList
        }, null, 512)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})